// extracted by mini-css-extract-plugin
export default {"buttonLink":"LandscapesOrganism_buttonLink__jXqpS","heading":"LandscapesOrganism_heading__YQojj","keyUsersWrapper":"LandscapesOrganism_keyUsersWrapper__rEZL7"};